import { render, staticRenderFns } from "./impayer.vue?vue&type=template&id=3c27509f&scoped=true"
import script from "./impayer.vue?vue&type=script&lang=js"
export * from "./impayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c27509f",
  null
  
)

export default component.exports